import { createFileRoute } from '@tanstack/react-router';
import { DeploymentLayout } from '@features/deployment/components/DeploymentLayout';
import { SystemVersionStatusTable } from "@features/deployment/components/systems-and-versions/SystemVersionStatusTable.tsx";
import { AdminPendingComponent } from '@features/admin/components/AdminPendingComponent';
import { AdminErrorComponent } from '@features/admin/components/AdminErrorComponent';

export const Route = createFileRoute('/_authed/admin/deployment-center/system-status/')({
  pendingComponent: AdminPendingComponent,
  errorComponent: AdminErrorComponent,
  component: SystemStatusPage
});

function SystemStatusPage() {
  return (
    <DeploymentLayout>
      <SystemVersionStatusTable/>
    </DeploymentLayout>
  );
}